@if (items.length > 0) {
<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
  @for (item of items; track item) { @if (item | async; as data) {
  <div ngxSlickItem class="slide">
    <div class="item">
      <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
        <span class="prod-image">
          <cx-media
            [container]="getImageRendition(data?.images?.PRIMARY)"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
        </span>
        <span class="prod-sku">
          {{ data.code }}
        </span>
        <span class="prod-name" [innerHTML]="data.name"></span>
        <span class="prod-price">
          @if (!showSrp) {
          <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
          <span class="p-price">
            @if (!dealerPrice(data.code)) {
            <div class="spinner-shimano-wrapper-dp">
              @if (this.hasDealerPrice) {
              <div class="spinner-shimano">
                <div></div>
              </div>
              } @if (!this.hasDealerPrice) {
              <div class="no-dealer-price no-dealer-price-pcn"></div>
              }
            </div>
            } @else {
            {{ dealerPrice(data.code) }}
            }
          </span>
          } @if (showSrp) {
          <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
          <span class="p-price">{{ data.srpPrice?.formattedValue }}</span>
          }
        </span>
      </a>
    </div>
  </div>
  } }
</ngx-slick-carousel>
}
